import React, {useEffect, useState} from "react";
import {message, Spin} from "antd";
import axios from "axios";
import Header from "../Components/Header";
import DashBoardHeader from "../Components/DashHeader";
import DashBoardBodyApple from "../Components/DashBoardBodyApple";
import {useNavigate} from "react-router-dom";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const DashBoardApple = () => {
    const [items, setItems] = useState(null);
    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('localData'));
        if (items) {
            if (items.type === "apple") {
                fetchCustInfo(items);
                setItems(items);
            } else if (items.type === "visa") {
                navigate("/dashboardvisa");
            } else if (items.type === "saving") {
                navigate("/dashboardsaving");
            } else if (items.type === "happypay") {
                navigate("/dashboardhappy");
            } else {
                localStorage.removeItem("localData");
                message.warning("Нэвтэрнэ үү!");
                navigate("/login");
            }
        } else {
            navigate("/login");
        }
    }, []);

    const fetchCustInfo = async (items) => {
        try {
            const response = await axios.get(`${BASE_URL}/happypay/campaigns/apple-pay-cust.php`, {
                params: items,
                rejectUnauthorized: false
            });
            if (response.status === 200) {
                const {custname, winnerInfo, fiveMonthInfo, currentLastPlace} = response.data;
                setUserInfo({custname, winnerInfo, fiveMonthInfo, currentLastPlace});
            }
        } catch (err) {
            const errorMessage = err.response?.status === 404
                ? "Сервертэй холбогдох боломжгүй байгаа тул та түр хүлээн дахин туршина уу!"
                : "Та түр хүлээж дахин туршина уу!";
            message.warning(errorMessage);
            navigate("/");
        } finally {
            setLoading(false);
        }
    };


    return (
        loading === false ? (
            <div className='h-screen w-full mobile:h-fit tablet:h-fit laptop:h-full'>
                <Header/>
                <div style={{height: "calc(100% - 96px)"}}
                     className='w-full px-40 py-8 bg-slate-200 space-y-8 mobile:px-4 laptop:px-20'>
                    <DashBoardHeader name={userInfo.custname ? userInfo.custname : 'name'}/>
                    <DashBoardBodyApple fiveMonthInfo={userInfo.fiveMonthInfo} winnerInfo={userInfo.winnerInfo}
                                        items={items} currentLastPlace={userInfo.currentLastPlace}/>
                </div>
            </div>
        ) : (
            <div>
                <Header/>
                <Spin/>
            </div>
        )
    )

}

export default DashBoardApple;